export default __webpack_public_path__ + "static/media/chomp-head@2x.8770d24d.png";